export const INIT_ROOM = 'events/INIT_ROOM';

/**
 * @return {{type: string}}
 */
export const initRoom = () => ({ type: INIT_ROOM });
